export default {
  // 用户信息
  userInfo: {},
  token: ''
};



// WEBPACK FOOTER //
// ./src/store/states/index.js